import { ApolloLink, NextLink, Operation } from '@apollo/client';
import { localComms } from '../utils/localComms';

class OrdersSDKLink extends ApolloLink {
  request = (operation: Operation, forward: NextLink) => {
    const headers = operation.getContext().headers;
    localComms.updateHeaders(headers || {});
    return forward(operation);
  };
}

const localCommsLink = new OrdersSDKLink();

export default localCommsLink;
